/** Query flag appended by API after Google/SAML OAuth so SPA can finalize HttpOnly session without JWTs in the URL. */
export const SPA_OAUTH_SESSION_QUERY = "oauth_session";
